import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eApptCategory, eCLPRole, eFeatures } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { RoleFeaturePermissions, RoleListResponse, RoleResponse } from '../../../models/roleContainer.model';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { RoleService } from '../../../services/role.service';
import { MenuService } from '../../../services/menu.service';
import { MenuResponse, Menus } from '../../../models/menu.model';
import { EngageThemeService } from '../../../services/shared/engageTheme.service';
import homeMenu from '../../../../assets/json/menu.json';
import { Title } from '@angular/platform-browser';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Search, SearchListResponse } from '../../../models/search.model';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { ApppointmentResponse, ShareableApptUI, UpdateAppt } from '../../../models/appt.model';
import { LeadApptComponent } from '../../lead-module/common/lead-appt/lead-appt.component';
import { GlobalService } from '../../../services/global.service';
import { SVGIcon, gearIcon, questionCircleIcon } from "@progress/kendo-svg-icons";
import { AppointmentSettingService } from '../../../services/appointmentSetting.service';
import { LiveConnectService } from '../../../services/live-connect.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { ConfigDetails } from '../../../models/appConfig.model';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { SessionService } from '../../../services/shared/session.service';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
declare var $: any;
@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css'],
    animations: [
        trigger('submenuAnimation', [
            state('hidden', style({
                opacity: 0,
                transform: 'translateY(-10px)',
                display: 'none'
            })),
            state('visible', style({
                opacity: 1,
                transform: 'translateY(0)',
                display: 'block'
            })),
            transition('hidden => visible', [
                style({ display: 'block' }),
                animate('200ms ease-in')
            ]),
            transition('visible => hidden', [
                animate('150ms ease-out', style({ opacity: 0, transform: 'translateY(-10px)' }))
            ])
        ])
    ]
})
/** nav-menu component*/
export class NavMenuComponent implements OnInit {
    /** nav-menu ctor */

    @ViewChild('menuRef') menuRef!: ElementRef;

    public gear: SVGIcon = gearIcon;
    public question: SVGIcon = questionCircleIcon;
    simpleResponse: SimpleResponse;
    homeMenu: any[] = [];
    packageLogo: string = "";
    showConfig: boolean = true;
    encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    menus: Menus[];
    showSpinner: boolean = false;
    validImage: boolean = false;
    isShowRightLogo: boolean = true;

    menuResponse: MenuResponse;
    _roleListResponse: RoleListResponse = <RoleListResponse>{};
    _roleList: RoleResponse[] = [];
    currentSelectedId: string = "-1";
    currentSelectedParentId: string = "-1";
    currentSelectedChildId: string = "-1";
    showSearch: boolean = false;
    clpRole: number = 0;
    useImage: boolean = false;
    company: ClpCompany = <ClpCompany>{};
    contactId: number = 0;
    companyId: number = 0
    searchList: Search[] = [];
    inputBoxValue: string = "";
    @ViewChild('autocomplete') autocomplete: AutoCompleteComponent;

    isShowApptModal: boolean = false;
    shareableAppt: ShareableApptUI;
    @ViewChild('closeInputButton') closeInputButton: ElementRef;
    @ViewChild('leadApptChild') leadApptChild: LeadApptComponent;
    ownerId: number = 0;
    apptCategory: eApptCategory = eApptCategory.None;
    proposalID: number = 0;
    userProfileMenu: any = []
    blnIsIH: boolean = false;
    loading: boolean = true;
    isSRSManager: boolean = false;
    isLiveConnectClpUser: boolean = false;
    isShowLiveConnectLink: boolean;
    liveConnectUrl: string = '';
    isHomeMenuOpened: boolean;
    isProfileMenuOpened: boolean;
    isParentMenuOpened: boolean;
    private destroy$ = new Subject<void>();
    bcmSiteUrl: string = '';

    constructor(public _localService: LocalService,
        private _router: Router,
        private titleService: Title,
        public _roleService: RoleService,
        private _utilityService: UtilityService,
        private _MenuService: MenuService,
        private _globalService: GlobalService,
        private _appConfigService: AppconfigService,
        private readonly _somyThemeService: EngageThemeService,
        public _appointmentSettingService: AppointmentSettingService,
        private _liveConnectSrvc: LiveConnectService,
        private _searchContactService: SearchContactService,
        private _sessionService: SessionService,
        private _accountSetupService: AccountSetupService) {
        // this.themeChangeHandler('aldaaysi_agency');
        //this.setRouteUrlForLogedInUser();

    }

    ngOnInit() {

        this.setRouteUrlForLogedInUser();
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.setUserProfileMenu()
                        this.getCompanyData();
                        this.getConfig();
                        this.getBCMSite();
                        this.getMenu();
                        this.loading = false;
                        this.getEngageSiteUrl();
                        this.homeMenu = homeMenu.homeMenu;
                        //this.homeMenu[0].icon = "../../../../assets/homeicon.svg";
                        delete this.homeMenu[0].icon;
                        window.localStorage.setItem('sc_lastUser', String(this.user?.cLPUserID));

                        this.liveConnect_isLiveConnectSRSAccount().then(() => {
                            this.IsLiveConnectCLPUser().then(() => {
                                if (this.user.slurpyUserId > 0 || this.isSRSManager || this.isLiveConnectClpUser) {
                                    this.isShowLiveConnectLink = true;
                                }
                            });
                        });
                    }
                    else {
                        //this._router.navigate(['/login']);

                    }
                });
            }
            else {
                //this._router.navigate(['/login']);

            }
        });


        this._localService.getUpdatedUser().pipe(takeUntil(this.destroy$)).subscribe(response => {
            if (response) {
                this.user = response;
                this.setUserProfileMenu()
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async getConfig() {
        await this._appConfigService.getAppConfigValue(this.encryptedUser, "liveconnect")
            .then(async (result: ConfigDetails) => {
                if (result) {
                    this.liveConnectUrl = result.configValue;
                }
            });
    }

    async getBCMSite() {
        await this._appConfigService.getAppConfigValue(this.encryptedUser, "bcmsite").then(
            (result: ConfigDetails) => {
                if (result) {
                    this.bcmSiteUrl = result.configValue;
                }
            });
    }

    setRouteUrlForLogedInUser() {
        this._router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                let isFromHandle = sessionStorage.getItem("isFromHandle")


                if (this.encryptedUser && this.user?.cLPUserID) {
                    // Remove calling menu get on each route changed.

                    //console.log("menu called setRouteUrlForLogedInUser.")
                    //this.getMenu();
                    this.loading = false;
                }
                if ((this._router.url !== '/login') && (this._router.url !== '/unauthorized'))
                    window.localStorage.setItem('sc_currentNav', this._router.url);
                if ((this._router.url == '/' || this._router.url == '/login' || this._router.url == '/unauthorized' || this._router.url == null) && isFromHandle != "true")
                    window.localStorage.setItem('sc_currentNav', '/home');
            }
        });
    }

    setUserProfileMenu() {
        this.userProfileMenu = [
            {
                text: this.user?.firstName + " " + this.user?.lastName,
                items: [
                    { text: "Edit Profile", path: '/edit-profile/' + this.user?.cLPUserID, items: [] },
                    {
                        text: "Sign out",
                        path: '',
                        items: [],
                    },
                ],
            }
        ];
    }

    onSelectUserMenu(item) {
        switch (item?.text) {
            case "Sign out":
                this.logout();
                break;
        }
    }


    themeChangeHandler(themeToSet) {
        this._somyThemeService.setTheme(themeToSet);
    }

    private async getMenu() {
        await this._MenuService.getMenu(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: MenuResponse) => {
                if (result) {
                    this.menuResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.menuResponse) && !isNullOrUndefined(this.menuResponse.menus)) {
                        this.menus = this.menuResponse.menus;
                        /*    if (this.menus[this.menus.length - 1].text != "Control Panel") {
                              this.menus = this.moveArrayItemToNewIndex(this.menus, this.menus.length - 2, this.menus.length - 1)
                            }*/
                        var removeUrlArr = [];
                        this.menus.forEach(e => {
                            if (e.text == 'Help') {
                                (e as any).i_con = 'help-icon';
                                (e as any).svgIcon = this.question;
                                delete e.text;
                            } else if (e.text == 'Control Panel') {
                                (e as any).i_con = 'setting-icon';
                                (e as any).svgIcon = this.gear;
                                delete e.text;
                            }
                            delete e.url;
                            removeUrlArr.push(e);
                        })
                        this.menus = removeUrlArr;
                        this.menus = this.mapItems(this.menus);
                        this.menus.forEach(item => {
                            if (item.text == 'Companies' || item.text == 'Contacts' || item.text == 'Leads') {
                                if (item.items && item.items.length > 0) {
                                    item.items = item.items.filter((data) => !(data.text === 'Recent' && (!data.items || data.items.length === 0)));
                                }
                            }
                        });
                        this.menus.forEach((z_item, i) => {
                            (z_item as any).uID = i;
                            if (z_item.items.length > 0) {
                                z_item.items.forEach((f_item, j) => {
                                    (f_item as any).uID = j;
                                    if (f_item.items.length > 0) {
                                        f_item.items.forEach((s_item, k) => {
                                            (s_item as any).uID = k;
                                            if (s_item.items.length > 0) {
                                                s_item.items.forEach((t_item, l) => {
                                                    (t_item as any).uID = l;
                                                })
                                            }
                                        })
                                    }
                                });
                            }
                        });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'cLPUserID ' + this.user?.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }



    private mapItems(menu: any, path?: string): any[] {
        return menu.map((item) => {
            const result: any = {
                svgIcon: item.svgIcon,
                icon: item.icon,
                text: item.text,
                path: item.url,
                i_con: item?.i_con,
            };
            if (item.items) {
                result.items = this.mapItems(item.items, item.url);
            }
            return result;
        });
    }

    async getRoles(isFirstSelected: boolean = true) {
        this.showSpinner = true;
        await this._roleService.engageRoles_get(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: RoleListResponse) => {
                if (result) {
                    this._roleListResponse = UtilityService.clone(result);
                    this._roleList = this._roleListResponse.roleList;
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    //await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        this.user = this.userResponse.user;
                        this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this._utilityService.handleErrorResponse(err);
            });
    }


    getCompanyData() {
        this._accountSetupService.getClpCompany(this.encryptedUser, this.user?.cLPCompanyID)
            .then((result: CompanyResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.company = response?.company;
                    localStorage.setItem("company", JSON.stringify(this.company));
                    this.clpRole = response.company.cLPRole;
                    this.useImage = response.company.useImage;
                    this.getImgSrc();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    logout() {
        this._localService.userToken_Signout(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result) && result.messageBool) {
                    this._globalService.requestedUrl = '';
                    localStorage.removeItem("token");
                    localStorage.clear();
                    this.titleService.setTitle('Engage');
                    this._sessionService.logout();
                    this._router.navigate(['/']);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    public onSelectHome(item, e: MouseEvent): void {
        if (!isNullOrUndefined(item.text) && item.text != '') {
            switch (item.text) {
                case "Documents":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("my-documents");
                    }
                    else {
                        this._router.navigate(['/my-documents']);
                        this.titleService.setTitle('Documents');
                        localStorage.setItem("title", 'Documents');
                    }

                    break;
                case "My Profile":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("edit-profile/" + this.user?.cLPUserID);
                    }
                    else {
                        this._router.navigate(['/edit-profile', this.user?.cLPUserID]);
                        this.titleService.setTitle('Edit Profile');
                        localStorage.setItem("title", 'Edit Profile');
                    }

                    break;
                case "Schedule":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("calendar/scheduler");
                    }
                    else {
                        this._router.navigate(['/calendar/scheduler']);
                        this.titleService.setTitle('Calendar Scheduler');
                        localStorage.setItem("title", 'Calendar Scheduler');
                    }
                    break;
                case "Call List":
                    var routeUrl: string = '';
                    routeUrl = this.user?.cLPCompanyID === 1226 ? 'call-ih' : 'call';
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open(routeUrl);
                    }
                    else {
                        this._router.navigateByUrl(routeUrl);
                        this.titleService.setTitle('Call');
                        localStorage.setItem("title", 'Call');
                    }
                    break;
                case "Goals":
                case "View Goals":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("/goal");
                    }
                    else {
                        this._router.navigate(['/goal']);
                        this.titleService.setTitle('View Goal');
                        localStorage.setItem("title", 'View Goal');
                    }
                    break;
                case "Tasks":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("/task");
                    }
                    else {
                        this._router.navigate(['/task']);
                        this.titleService.setTitle('View Task');
                        localStorage.setItem("title", 'View Task');
                    }
                    break;
                case "Home":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("/home");
                    }
                    else {
                        this._router.navigate(['/home']);
                        this.titleService.setTitle('Home');
                        localStorage.setItem("title", 'Home');
                    }
                    break;
                case "Mailings":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("marketing/view?type=2");
                    }
                    else {
                        this._router.navigateByUrl('marketing/view?type=2');
                        this.titleService.setTitle('Mailing');
                        localStorage.setItem("title", 'Mailing');
                    }
                    break;
                case "Goals Setup":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("goal/setup");
                    }
                    else {
                        this._router.navigate(['goal/setup']);
                        this.titleService.setTitle('Setup Goal');
                        localStorage.setItem("title", 'Setup Goal');
                    }
                    break;
                case "New Appointment":
                    if (this.user?.cLPCompanyID == 1226 || this.user?.cLPCompanyID == 1321) {
                        if (e?.ctrlKey || e?.metaKey) {
                            var w = window.open("appointment-ih");
                        }
                        else {
                            this._router.navigate(['/appointment-ih'])
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');
                        }
                    }
                    else {
                        if (e?.ctrlKey || e?.metaKey) {
                            var w = window.open("appointment");
                        }
                        else {
                            this._router.navigate(['/appointment']);
                            this.titleService.setTitle('New Appointment');
                            localStorage.setItem("title", 'New Appointment');
                        }
                    }
                    break;
                case "Appointment List":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("appointment-list");
                    }
                    else {
                        this._router.navigate(['/appointment-list']);
                        this.titleService.setTitle('Appointment List');
                        localStorage.setItem("title", 'Appointment List');
                    }
                    break;
                case "Bulk Appointment Wizard":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("bulk-appointment");
                    }
                    else {
                        this._router.navigate(['bulk-appointment']);
                        this.titleService.setTitle('Bulk Appointment Wizard');
                        localStorage.setItem("title", 'Bulk Appointment Wizard');
                    }
                    break;
                case "New Recurring Appointment":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("calendar/recurringappt");
                    }
                    else {
                        this._router.navigate(['calendar/recurringappt']);
                        this.titleService.setTitle('New Recurring Appointment');
                        localStorage.setItem("title", 'New Recurring Appointment');
                    }
                    break;
                case "Dynamic Schedulers":
                    if (e?.ctrlKey || e?.metaKey) {
                        var w = window.open("calendar/pcallist");
                    }
                    else {
                        this._router.navigate(['calendar/pcallist']);
                        this.titleService.setTitle('Public Calendar List');
                        localStorage.setItem("title", 'Dynamic Schedulers');
                    }
                    break;
                default:
                    $('#underConstruction').modal('show');
                    break;
            }
            this.currentSelectedId = "-1";
            this.currentSelectedParentId = "-1";
        }
    }

    public onSelectParent(item, type: string, e: MouseEvent) {
        type = '' + type;
        if (item.items.length == 0) {
            if (item.path != "") {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                if (item.path?.includes("ih_redirect")) {
                    this.simpleResponse = <SimpleResponse>{};
                    this.simpleResponse.messageString = item.path?.split("p=")[1];
                    this.authenicateIHRedirect(this.simpleResponse)
                }
                if (item.text != "") {
                    switch (item.text) {
                        case "View": {
                            if (item.path?.includes("lead-detail")) {
                                let leadId = Number(item.path.split("lead-detail/")[1]);
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open("lead-detail/" + leadId);
                                }
                                else {
                                    this._router.navigate(['/lead-detail', leadId]);
                                }
                            }
                            else if (item.path?.includes("/company-create")) {
                                let cid = Number(item.path.split("cid=")[1]);
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open(`company-create?cid=${cid}`);
                                }
                                else {
                                    this._router.navigateByUrl(`company-create?cid=${cid}`);
                                }
                                break;
                            }
                            else {
                                let contactId = Number(this.getIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open("contact/" + contactId);
                                }
                                else {
                                    this._router.navigate(['/contact', contactId]);
                                }
                            }
                            break;
                        }
                        case "Create Referral": {
                            let rId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                rId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(`contact-create?rid=${rId}`);
                            }
                            else {
                                this._router.navigateByUrl(`contact-create?rid=${rId}`);
                            }
                            break;
                        }
                        case "View History": {
                            let contactId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path?.substring(lastIndex + 1);
                                contactId = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open('contact/history/' + this.user?.cLPUserID + "/" + contactId);
                            }
                            else {
                                this._router.navigate(['/contact/history', this.user?.cLPUserID, contactId]);
                            }
                            break;
                        }
                        case "View Documents": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open('my-documents/' + id + '/' + category);
                            }
                            else {
                                this._router.navigate(['/my-documents', id, category]);
                            }
                            break;
                        }
                        case "New Appointment": {
                            this.isShowApptModal = true;
                            $('#quickApptModal').modal('show');
                            if (item.path?.includes("cat=2")) {
                                let val = item.path?.split("id=")[1];
                                this.ownerId = Number(val?.split("&mde")[0]);
                                this.apptCategory = eApptCategory.Contact
                                this.appointmentPopUp(null, true)
                            }
                            else {
                                let val = item.path?.split("id=")[1];
                                this.ownerId = Number(val?.split("&mde")[0]);
                                this.apptCategory = eApptCategory.Lead
                                this.appointmentPopUp(null, true)
                            }

                            break;
                        }
                        case "View Appointments": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            this._localService.ownerId.next(id);
                            this._localService.apptCategory.next(eApptCategory.CompanyObject);
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open('/appointment-list/' + id + '/' + category);
                            }
                            else {
                                this._router.navigate(['/appointment-list', id, category]);
                            }
                            break;
                        }
                        case "New Lead": {
                            let cid = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                cid = Number(part2);
                            }
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(`lead-create?cid=${cid}`);
                            }
                            else {
                                this._router.navigateByUrl(`lead-create?cid=${cid}`);
                            }
                            break;
                        }
                        case "New Contact": {
                            let cid = Number(item.path.split("cid=")[1]);
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(`/contact-create?cid=${cid}`);
                            }
                            else {
                                this._router.navigateByUrl(`/contact-create?cid=${cid}`)
                            }
                            break;
                        }
                        case "View Tasks": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open("task/" + id + "/" + category);
                            }
                            else {
                                this._router.navigate(['/task', id, category]);
                            }
                            break;
                        }
                        case "Edit": {
                            if (item.path?.includes("lead-detail")) {
                                let value = item.path?.split("lead-detail/")[1];
                                let leadId = Number(value?.split("&")[0]);
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open("lead-detail/" + leadId);
                                }
                                else {
                                    this._router.navigate(['/lead-detail/', leadId]);
                                }
                            }
                            else {
                                let contactId = Number(this.getIdFromPath(item.path));
                                if (e?.ctrlKey || e?.metaKey) {
                                    window.open("contact/" + contactId);
                                }
                                else {
                                    this._router.navigate(['/contact', contactId]);
                                }
                            }
                            break;
                        }
                        case "New Task": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open("task/" + id + "/" + category + "?isNew=true");
                            }
                            else {
                                this._router.navigate(['/task', id, category], { queryParams: { isNew: true } });
                            }
                            break;
                        }
                        case "Club Manager": {
                            //window.open("/bcm-redirect", '_blank');
                            window.open(`${this.bcmSiteUrl}cm-dashboard`, '_blank');
                            break;
                        }
                        case "Membership": {
                            window.open(`${this.bcmSiteUrl}mem-membership-list`, '_blank');
                            break;
                        }
                        default: {
                            if (e?.ctrlKey || e?.metaKey) {
                                window.open(item.path);
                            }
                            else {
                                this._router.navigateByUrl(item.path);
                                this.titleService.setTitle(item.text);
                            }

                            localStorage.setItem("title", item.text);
                            break;
                        }

                    }

                }
                this.toggleNavBar();
            }
            else {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                $('#underConstruction').modal('show');
                this.toggleNavBar();
            }
        } else {
            if (item.i_con) {
                var split_string = item.i_con?.split("/");
                var newitem = split_string[split_string.length - 1];
                newitem = newitem.replace(/ /g, "").toLowerCase();
            } else if (item.text) {
                var newitem = item.text.replace(/ /g, "").toLowerCase();
            }

            switch (type) {
                case "0": {
                    //for hiding toggler on click of icon
                    if (item.i_con) {
                        this.toggleNavBar();
                        if (this.showSearch)
                            this.showSearch = !this.showSearch;
                    }


                    if (this.currentSelectedParentId == newitem)
                        this.currentSelectedParentId = "-1";
                    else
                        this.currentSelectedParentId = newitem;
                    break;
                }
                case "1": {
                    if (this.currentSelectedId == newitem)
                        this.currentSelectedId = "-1";
                    else
                        this.currentSelectedId = newitem;
                    break;
                }
                case "2": {
                    if (this.currentSelectedChildId == newitem)
                        this.currentSelectedChildId = "-1";
                    else
                        this.currentSelectedChildId = newitem;
                    break;
                }
                default: {
                    break;
                }
            }
        }

    }

    setHomeMenuUrl(item) {
        switch (item?.text) {
            case "Documents":
                return '/my-documents';
            case "Calendar":
                return '/calendar';
            case "Profile":
                return "edit-profile/" + this.user?.cLPUserID;
            case "Schedule":
                return "calendar/scheduler";
            case "Call List":
                var routeUrl: string = '';
                routeUrl = this.user?.cLPCompanyID === 1226 ? 'call-ih' : 'call';
                return routeUrl;
            case "Goals":
            case "View Goals":
                return '/goal';
            case "Tasks":
                return "/task";
            case "Home":
                return '/home';
            case "Mailings":
                return "marketing/view";
            case "Setup Goals":
                return "goal/setup";
            case "New Appointment":
                var routeUrl: string = '';
                routeUrl = this.user?.cLPCompanyID == 1226 || this.user?.cLPCompanyID == 1321 ? '/appointment-ih' : '/appointment';
                return routeUrl;
            case "Appointment List":
                return "appointment-list";
            case "Bulk Appointment Wizard":
                return "bulk-appointment";
            case "New Recurring Appointment":
                return "calendar/recurringappt";
            case "Dynamic Schedulers":
                return "calendar/pcallist";
        }
    }

    onSelectHomeDesktop(event) {
        if (event.ctrlKey || event.metaKey) {
            event.stopPropagation();
            return;
        }
        this.currentSelectedId = "-1";
        this.currentSelectedParentId = "-1";

    }

    //public onSelectHomeDesktop(itemObj): void {
    //    let e = itemObj?.originalEvent
    //    let item = itemObj?.item
    //    if (item?.text && item?.text != '') {
    //        switch (item?.text) {
    //            case "Documents":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("my-documents");
    //                }
    //                else {
    //                    this._router.navigate(['/my-documents']);
    //                    this.titleService.setTitle('Documents');
    //                    localStorage.setItem("title", 'Documents');
    //                }

    //                break;
    //            case "Calendar":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("calender");
    //                }
    //                else {
    //                    this._router.navigate(['/calender']);
    //                    this.titleService.setTitle('calender');
    //                    localStorage.setItem("title", 'calender');
    //                }
    //                break;
    //            case "My Profile":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("edit-profile/" + this.user?.cLPUserID);
    //                }
    //                else {
    //                    this._router.navigate(['/edit-profile', this.user?.cLPUserID]);
    //                    this.titleService.setTitle('Edit Profile');
    //                    localStorage.setItem("title", 'Edit Profile');
    //                }

    //                break;
    //            case "Schedule":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("calender/scheduler");
    //                }
    //                else {
    //                    this._router.navigate(['/calender/scheduler']);
    //                    this.titleService.setTitle('Calender Scheduler');
    //                    localStorage.setItem("title", 'Calender Scheduler');
    //                }
    //                break;
    //            case "Call List":
    //                var routeUrl: string = '';
    //                routeUrl = this.user?.cLPCompanyID === 1226 ? 'call-ih' : 'call';
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open(routeUrl);
    //                }
    //                else {
    //                    this._router.navigateByUrl(routeUrl);
    //                    this.titleService.setTitle('Call');
    //                    localStorage.setItem("title", 'Call');
    //                }
    //                break;
    //            case "Goals":
    //            case "View Goals":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("/goal");
    //                }
    //                else {
    //                    this._router.navigate(['/goal']);
    //                    this.titleService.setTitle('View Goal');
    //                    localStorage.setItem("title", 'View Goal');
    //                }
    //                break;
    //            case "Tasks":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("/task");
    //                }
    //                else {
    //                    this._router.navigate(['/task']);
    //                    this.titleService.setTitle('View Task');
    //                    localStorage.setItem("title", 'View Task');
    //                }
    //                break;
    //            case "Home":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("/home");
    //                }
    //                else {
    //                    this._router.navigate(['/home']);
    //                    this.titleService.setTitle('Home');
    //                    localStorage.setItem("title", 'Home');
    //                }
    //                break;
    //            case "Mailings":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("marketing/view?type=2");
    //                }
    //                else {
    //                    this._router.navigateByUrl('marketing/view?type=2');
    //                    this.titleService.setTitle('Mailing');
    //                    localStorage.setItem("title", 'Mailing');
    //                }
    //                break;
    //            case "Goals Setup":

    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("goal/setup");
    //                }
    //                else {
    //                    this._router.navigate(['goal/setup']);
    //                    this.titleService.setTitle('Setup Goal');
    //                    localStorage.setItem("title", 'Setup Goal');
    //                }

    //                break;
    //            case "New Appointment":
    //                if (this.user?.cLPCompanyID == 1226 || this.user?.cLPCompanyID == 1321) {
    //                    if (e?.ctrlKey || e?.metaKey) {
    //                        var w = window.open("appointment-ih");
    //                    }
    //                    else {
    //                        this._router.navigate(['/appointment-ih'])
    //                        this.titleService.setTitle('New Appointment');
    //                        localStorage.setItem("title", 'New Appointment');
    //                    }
    //                }
    //                else {
    //                    if (e?.ctrlKey || e?.metaKey) {
    //                        var w = window.open("appointment");
    //                    }
    //                    else {
    //                        this._router.navigate(['/appointment']);
    //                        this.titleService.setTitle('New Appointment');
    //                        localStorage.setItem("title", 'New Appointment');
    //                    }
    //                }
    //                break;
    //            case "Appointment List":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("appointment-list");
    //                }
    //                else {
    //                    this._router.navigate(['/appointment-list']);
    //                    this.titleService.setTitle('Appointment List');
    //                    localStorage.setItem("title", 'Appointment List');
    //                }
    //                break;
    //            case "Bulk Appointment Wizard":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("bulk-appointment");
    //                }
    //                else {
    //                    this._router.navigate(['bulk-appointment']);
    //                    this.titleService.setTitle('Bulk Appointment Wizard');
    //                    localStorage.setItem("title", 'Bulk Appointment Wizard');
    //                }
    //                break;
    //            case "New Recurring Appointment":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("calendar/recurringappt");
    //                }
    //                else {
    //                    this._router.navigate(['calendar/recurringappt']);
    //                    this.titleService.setTitle('New Recurring Appointment');
    //                    localStorage.setItem("title", 'New Recurring Appointment');
    //                }
    //                break;
    //            case "Dynamic Schedulers":
    //                if (e?.ctrlKey || e?.metaKey) {
    //                    var w = window.open("calendar/pcallist");
    //                }
    //                else {
    //                    this._router.navigate(['calendar/pcallist']);
    //                    this.titleService.setTitle('Public Calendar List');
    //                    localStorage.setItem("title", 'Dynamic Schedulers');
    //                }
    //                break;
    //            default:
    //                $('#underConstruction').modal('show');
    //                break;
    //        }
    //        this.currentSelectedId = "-1";
    //        this.currentSelectedParentId = "-1";
    //    }
    //}

    setQueryParamsParent(item) {
        if (item.items.length == 0) {
            if (!isNullOrUndefined(item.path) && item.path != "") {
                if (item.text != "") {
                    switch (item.text) {
                        case "View": {
                            if (item.path?.includes("/company-create")) {
                                let cid = Number(item.path.split("cid=")[1]);
                                return { cid: cid };
                            }
                        }
                        case "View Mailings": {
                            if (item.path?.includes("/marketing/view")) {
                                let type = Number(item.path.split("type=")[1]);
                                return { type: type };
                            }
                        }
                        case "Create Referral": {
                            let rId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                rId = Number(part2);
                            }
                            return { rid: rId };
                        }
                        case "New Lead": {
                            let cid = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                cid = Number(part2);
                            }
                            return { cid: cid };
                        }
                        case "New Contact": {
                            let cid = Number(item.path.split("cid=")[1]);
                            return { cid: cid };
                        }
                        case "New Task": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            return { isNew: true };
                        }
                        case "New": {
                            if (item.path?.includes("company-create")) {
                                return { isNew: 'y' };
                            }
                        }
                        case "View History": {
                            return { ch: true }
                        }
                        default: {
                            return {};
                        }

                    }

                }

            }
        }
        else {
            if (item.text == 'Direct Mail') {
                return { type: 1 };
            }
            else if (item.text == "Email Marketing") {
                return { type: 2 };
            }
            else if (item.text == "Text Messaging") {
                return { type: 6 };
            }
            else if (item.path?.includes("company-create")) {
                let cid = Number(item.path.split("cid=")[1]);
                return { cid: cid };
            }
        }
    }

    setParentMenuUrl(item) {
        if (item.items.length == 0) {
            if (!isNullOrUndefined(item.path) && item.path != "") {
                if (item.text != "") {
                    switch (item.text) {
                        case "View": {
                            if (item.path?.includes("lead-detail")) {
                                let leadId = Number(item.path.split("lead-detail/")[1]);
                                return "lead-detail/" + leadId;
                            }
                            else if (item.path?.includes("/company-create")) {
                                let cid = Number(item.path.split("cid=")[1]);
                                return `company-create`
                            }
                            else {
                                let contactId = Number(this.getIdFromPath(item.path));
                                return "contact/" + contactId;
                            }
                        }
                        case "Create Referral": {
                            let rId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                rId = Number(part2);
                            }
                            return `contact-create`;
                        }
                        case "View History": {
                            let contactId = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path?.substring(lastIndex + 1);
                                contactId = Number(part2);
                            }

                            return 'activity-history/' + contactId;
                            //return 'contact/history/' + this.user?.cLPUserID + "/" + contactId;
                        }
                        case "View Documents": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            return 'my-documents/' + id + '/' + category;
                        }
                        case "New Appointment": {
                            //this.isShowApptModal = true;
                            //$('#quickApptModalMenu').modal('show');
                            //if (item.path?.includes("cat=2")) {
                            //    let val = item.path?.split("id=")[1];
                            //    this.ownerId = Number(val?.split("&mde")[0]);
                            //    this.apptCategory = eApptCategory.Contact
                            //    this.appointmentPopUp(null, true)
                            //}
                            //else {
                            //    let val = item.path?.split("id=")[1];
                            //    this.ownerId = Number(val?.split("&mde")[0]);
                            //    this.apptCategory = eApptCategory.Lead
                            //    this.appointmentPopUp(null, true)
                            //}

                            //break;
                        }
                        case "View Appointments": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            this._localService.ownerId.next(id);
                            this._localService.apptCategory.next(eApptCategory.CompanyObject);
                            return '/appointment-list/' + id + '/' + category;
                        }
                        case "New Lead": {
                            let cid = 0;
                            const lastIndex = item.path?.lastIndexOf('/');
                            if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
                                const part2 = item.path.substring(lastIndex + 1);
                                cid = Number(part2);
                            }
                            return `lead-create`;
                        }
                        case "New Contact": {
                            let cid = Number(item.path.split("cid=")[1]);
                            return `/contact-create`;
                        }
                        case "View Tasks": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            return "task/" + id + "/" + category;
                        }
                        case "Edit": {
                            if (item.path?.includes("lead-detail")) {
                                let value = item.path?.split("lead-detail/")[1];
                                let leadId = Number(value?.split("&")[0]);
                                return "lead-detail/" + leadId;
                            }
                            else {
                                let contactId = Number(this.getIdFromPath(item.path));
                                return "contact/" + contactId;
                            }
                        }
                        case "New Task": {
                            let lastSlashIndex = item.path.lastIndexOf('/');
                            let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
                            let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
                            let id = Number(result);
                            let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
                            return "task/" + id + "/" + category;
                        }
                        case "New": {
                            if (item.path?.includes("company-create")) {
                                return "company-create";
                            }
                            if (item.path?.includes("contact-create")) {
                                return "contact-create";
                            }
                            if (item.path?.includes("lead-create")) {
                                return "lead-create";
                            }
                        }
                        case "Club Manager": {
                            return null;
                        }
                        case "Membership": {
                            return null;
                        }
                        case "View Mailings": {
                            return `marketing/view`
                        }
                        default: {
                            return item.path;
                        }
                    }
                }
            }
        }
        else {
            if (item.text == 'Contacts' && !(item.items[0].text == 'Contacts' || item.items[1].text == 'Contacts')) {
                return '/contacts';
            }
            else if (item.text == 'Direct Mail') {
                return '/marketing/view';
            }
            else if (item.text == "Email Marketing") {
                return '/marketing/view';
            }
            else if (item.text == "Text Messaging") {
                return '/marketing/view';
            }
            else if (item.text == "Sales Optimization") {
                return '/automation-process';
            }
            else if (item.text == "Manage Templates") {
                return '/email-template-list';
            }
            if (item.icon) {
                var split_string = item.icon?.split("/");
                var newitem = split_string[split_string.length - 1];
                newitem = newitem.replace(/ /g, "").toLowerCase();
            }
            else if (item.path == "recent-contacts" && item.text == "Recent") {
                return '/recent-contacts';
            }
            else if (item.path?.includes("contact/")) {
                let contactId = Number(this.getIdFromPath(item.path));
                return "contact/" + contactId;
            }
            else if (item.path?.includes("lead-detail/")) {
                let leadId = Number(this.getIdFromPath(item.path));
                return "lead-detail/" + leadId;
            }
            else if (item.path?.includes("company-create")) {
                return `/company-create`;
            }
            else if (item.text == "Activity") {
                return `/report/appttype`;
            }
            else if (item.text == "Company") {
                return `/company/rpt2dim`;
            }
            else if (item.text == "Contact") {
                return `/contact/rptdist_mng`;
            }
            else if (item.text == "Lead") {
                return `/project-revenue-manager`;
            }
            else if (item.text == "Module Settings") {
                return `/company-settings`;
            }
            else if (item.text == "SO Admin Settings") {
                return `/account-setting`;
            }

            else if (item.text) {
                var newitem = item.text.replace(/ /g, "").toLowerCase();
            }
        }
    }

    onParentMenuClick(event: MouseEvent, item: any, level: number): void {
        if (item.items?.length) {
            this.toggleTopMenuParent(item, event, level);
            return;
        }

        const url = this.setParentMenuUrl(item);
        const queryParams = this.setQueryParamsParent(item);
        if (item?.text == 'Club Manager') {
            window.open(`${this.bcmSiteUrl}cm-dashboard`, '_blank');
            //window.open('/bcm-redirect', '_blank');
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (item?.text == 'Membership') {
            window.open(`${this.bcmSiteUrl}mem-membership-list`, '_blank');
            event.stopPropagation();
            event.preventDefault();
            return;
        }

        if (event.ctrlKey || event.metaKey) {
            const fullUrl = this._router.serializeUrl(
                this._router.createUrlTree([url], { queryParams })
            );
            window.open(fullUrl, '_blank');
            event.stopPropagation();
            event.preventDefault();
        } else {
            this._router.navigate([url], { queryParams });
            this.onSelectParentDesktop(item, event);
            this.activeMenuLevelsParent = {};
            //this.toggleTopMenuParent(item, event, level);
        }
    }


    onSelectParentDesktop(item, event) {

        if (item.items.length == 0) {
            if (!isNullOrUndefined(item.path) && item.path != "") {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                if (item.path?.includes("ih_redirect")) {
                    this.simpleResponse = <SimpleResponse>{};
                    this.simpleResponse.messageString = item.path?.split("p=")[1];
                    this.authenicateIHRedirect(this.simpleResponse)
                }

                if (item.text != "") {
                    switch (item.text) {
                        case "New Appointment":
                            this.isShowApptModal = true;
                            $('#quickApptModalMenu').modal('show');
                            if (item.path?.includes("cat=2")) {
                                let val = item.path?.split("id=")[1];
                                this.ownerId = Number(val?.split("&mde")[0]);
                                this.apptCategory = eApptCategory.Contact
                                this.appointmentPopUp(null, true)
                            }
                            else {
                                let val = item.path?.split("id=")[1];
                                this.ownerId = Number(val?.split("&mde")[0]);
                                this.apptCategory = eApptCategory.Lead
                                this.appointmentPopUp(null, true)
                            }
                            break;
                        case "Club Manager":
                            //window.open("/bcm-redirect", '_blank');
                            window.open(`${this.bcmSiteUrl}cm-dashboard`, '_blank');
                            break;
                        case "Membership":
                            window.open(`${this.bcmSiteUrl}mem-membership-list`, '_blank');
                            break;

                    }

                }
                this.toggleNavBar();
            }
            else {
                this.currentSelectedId = "-1";
                this.currentSelectedParentId = "-1";
                this.currentSelectedChildId = "-1";
                $('#underConstruction').modal('show');
                this.toggleNavBar();
            }
        } else {
            if (item.icon) {
                var split_string = item.icon?.split("/");
                var newitem = split_string[split_string.length - 1];
                newitem = newitem.replace(/ /g, "").toLowerCase();
            }
            else if (item.text) {
                var newitem = item.text.replace(/ /g, "").toLowerCase();
            }
        }
    }

    //public onSelectParentDesktop(itemObj) {
    //    //type = '' + type;
    //    let e = itemObj?.originalEvent
    //    let item = itemObj?.item
    //    if (item.items.length == 0) {
    //        if (!isNullOrUndefined(item.path) && item.path != "") {
    //            this.currentSelectedId = "-1";
    //            this.currentSelectedParentId = "-1";
    //            this.currentSelectedChildId = "-1";
    //            if (item.path?.includes("ih_redirect")) {
    //                this.simpleResponse = <SimpleResponse>{};
    //                this.simpleResponse.messageString = item.path?.split("p=")[1];
    //                this.authenicateIHRedirect(this.simpleResponse)
    //            }

    //            if (item.text != "") {
    //                switch (item.text) {
    //                    case "View": {
    //                        if (item.path?.includes("lead-detail")) {
    //                            let leadId = Number(item.path.split("lead-detail/")[1]);
    //                            if (e?.ctrlKey || e?.metaKey) {
    //                                window.open("lead-detail/" + leadId);
    //                            }
    //                            else {
    //                                this._router.navigate(['/lead-detail', leadId]);
    //                            }
    //                        }
    //                        else if (item.path?.includes("/company-create")) {
    //                            let cid = Number(item.path.split("cid=")[1]);
    //                            if (e?.ctrlKey || e?.metaKey) {

    //                                window.open(`company-create?cid=${cid}`);
    //                            }
    //                            else {
    //                                this._router.navigateByUrl(`company-create?cid=${cid}`);

    //                            }
    //                            break;
    //                        }
    //                        else {
    //                            let contactId = Number(this.getIdFromPath(item.path));
    //                            if (e?.ctrlKey || e?.metaKey) {
    //                                window.open("contact/" + contactId);
    //                            }
    //                            else {


    //                                this._router.navigate(['/contact', contactId]);
    //                            }
    //                        }
    //                        break;
    //                    }
    //                    case "Create Referral": {
    //                        let rId = 0;
    //                        const lastIndex = item.path?.lastIndexOf('/');
    //                        if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
    //                            const part2 = item.path.substring(lastIndex + 1);
    //                            rId = Number(part2);
    //                        }
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open(`contact-create?rid=${rId}`);
    //                        }
    //                        else {
    //                            this._router.navigateByUrl(`contact-create?rid=${rId}`);

    //                        }
    //                        break;
    //                    }
    //                    case "View History": {
    //                        let contactId = 0;
    //                        const lastIndex = item.path?.lastIndexOf('/');
    //                        if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
    //                            const part2 = item.path?.substring(lastIndex + 1);
    //                            contactId = Number(part2);
    //                        }
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open('contact/history/' + this.user?.cLPUserID + "/" + contactId);
    //                        }
    //                        else {
    //                            this._router.navigate(['/contact/history', this.user?.cLPUserID, contactId]);
    //                        }
    //                        break;
    //                    }
    //                    case "View Documents": {
    //                        let lastSlashIndex = item.path.lastIndexOf('/');
    //                        let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
    //                        let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
    //                        let id = Number(result);
    //                        let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open('my-documents/' + id + '/' + category);
    //                        }
    //                        else {
    //                            this._router.navigate(['/my-documents', id, category]);

    //                        }
    //                        break;
    //                    }
    //                    case "New Appointment": {
    //                        this.isShowApptModal = true;
    //                        $('#quickApptModalMenu').modal('show');
    //                        if (item.path?.includes("cat=2")) {
    //                            let val = item.path?.split("id=")[1];
    //                            this.ownerId = Number(val?.split("&mde")[0]);
    //                            this.apptCategory = eApptCategory.Contact
    //                            this.appointmentPopUp(null, true)
    //                        }
    //                        else {
    //                            let val = item.path?.split("id=")[1];
    //                            this.ownerId = Number(val?.split("&mde")[0]);
    //                            this.apptCategory = eApptCategory.Lead
    //                            this.appointmentPopUp(null, true)
    //                        }

    //                        break;
    //                    }
    //                    case "View Appointments": {
    //                        let lastSlashIndex = item.path.lastIndexOf('/');
    //                        let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
    //                        let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
    //                        let id = Number(result);
    //                        let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
    //                        this._localService.ownerId.next(id);
    //                        this._localService.apptCategory.next(eApptCategory.CompanyObject);
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open('/appointment-list/' + id + '/' + category);
    //                        }
    //                        else {
    //                            this._router.navigate(['/appointment-list', id, category]);

    //                        }

    //                        break;
    //                    }
    //                    case "New Lead": {
    //                        let cid = 0;
    //                        const lastIndex = item.path?.lastIndexOf('/');
    //                        if (lastIndex !== -1 && lastIndex + 1 < item.path?.length) {
    //                            const part2 = item.path.substring(lastIndex + 1);
    //                            cid = Number(part2);
    //                        }
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open(`lead-create?cid=${cid}`);
    //                        }
    //                        else {
    //                            this._router.navigateByUrl(`lead-create?cid=${cid}`);

    //                        }
    //                        break;
    //                    }
    //                    case "New Contact": {
    //                        let cid = Number(item.path.split("cid=")[1]);
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open(`/contact-create?cid=${cid}`);
    //                        }
    //                        else {
    //                            this._router.navigateByUrl(`/contact-create?cid=${cid}`)

    //                        }
    //                        break;
    //                    }
    //                    case "View Tasks": {
    //                        let lastSlashIndex = item.path.lastIndexOf('/');
    //                        let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
    //                        let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
    //                        let id = Number(result);
    //                        let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open("task/" + id + "/" + category);
    //                        }
    //                        else {
    //                            this._router.navigate(['/task', id, category]);

    //                        }
    //                        break;
    //                    }
    //                    case "Edit": {
    //                        if (item.path?.includes("lead-detail")) {
    //                            let value = item.path?.split("lead-detail/")[1];
    //                            let leadId = Number(value?.split("&")[0]);
    //                            if (e?.ctrlKey || e?.metaKey) {

    //                                window.open("lead-detail/" + leadId);
    //                            }
    //                            else {
    //                                this._router.navigate(['/lead-detail/', leadId]);

    //                            }
    //                        }
    //                        else {
    //                            let contactId = Number(this.getIdFromPath(item.path));
    //                            if (e?.ctrlKey || e?.metaKey) {

    //                                window.open("contact/" + contactId);
    //                            }
    //                            else {
    //                                this._router.navigate(['/contact/', contactId]);

    //                            }
    //                        }
    //                        break;
    //                    }
    //                    case "New Task": {
    //                        let lastSlashIndex = item.path.lastIndexOf('/');
    //                        let secondLastSlashIndex = item.path.lastIndexOf('/', lastSlashIndex - 1);
    //                        let result = item.path.substring(secondLastSlashIndex + 1, lastSlashIndex);
    //                        let id = Number(result);
    //                        let category = item.path.substring(lastSlashIndex + 1, lastSlashIndex + 2);
    //                        if (e?.ctrlKey || e?.metaKey) {

    //                            window.open("task/" + id + "/" + category + "?isNew=true");
    //                        }
    //                        else {
    //                            this._router.navigate(['/task', id, category], { queryParams: { isNew: true } });

    //                        }
    //                        break;
    //                    }
    //                    case "Club Manager": {
    //                        window.open("/bcm-redirect", '_blank');
    //                        break;
    //                    }
    //                    default: {
    //                        if (e?.ctrlKey || e?.metaKey) {
    //                            window.open(item.path);
    //                        }
    //                        else {
    //                            if (item.path?.includes("/help/")) {
    //                                window.open(item.path);
    //                            }
    //                            else {
    //                                this._router.navigateByUrl(item.path);
    //                                this.titleService.setTitle(item.text);
    //                            }

    //                        }

    //                        localStorage.setItem("title", item.text);
    //                        break;
    //                    }

    //                }

    //            }
    //            this.toggleNavBar();
    //        }
    //        else {
    //            this.currentSelectedId = "-1";
    //            this.currentSelectedParentId = "-1";
    //            this.currentSelectedChildId = "-1";
    //            $('#underConstruction').modal('show');
    //            this.toggleNavBar();
    //        }
    //    } else {
    //        if (item.text == 'Contacts' && !(item.items[0].text == 'Contacts' || item.items[1].text == 'Contacts')) {
    //            this._router.navigate(['/contacts']);
    //        }
    //        else if (item.text == 'Direct Mail') {
    //            this._router.navigate(['/marketing/view', 1]);
    //        }
    //        if (item.icon) {
    //            var split_string = item.icon?.split("/");
    //            var newitem = split_string[split_string.length - 1];
    //            newitem = newitem.replace(/ /g, "").toLowerCase();
    //        }
    //        else if (item.path == "recent-contacts" && item.text == "Recent") {
    //            this._router.navigate(['/recent-contacts']);
    //        }
    //        else if (item.path?.includes("contact/")) {
    //            let contactId = Number(this.getIdFromPath(item.path));
    //            if (e?.ctrlKey || e?.metaKey) {
    //                window.open("contact/" + contactId);
    //            }
    //            else {
    //                this._router.navigate(['/contact', contactId]);
    //            }
    //        }
    //        else if (item.text) {
    //            var newitem = item.text.replace(/ /g, "").toLowerCase();
    //        }
    //    }

    //}

    onMouseOver(item, type: string) {
        this.menus?.forEach(z_item => {
            if (type == '0') {
                if (((!isNullOrUndefined(item?.text) && z_item.text == item?.text) || (!isNullOrUndefined(item.icon) && z_item.icon == item.icon)) && (z_item as any).uID == item?.uID)
                    (z_item as any).dClass = 'active';
                else
                    (z_item as any).dClass = '';
            }
            if (z_item.items.length > 0) {
                z_item.items.forEach(f_item => {
                    if (type == '1') {
                        if (((!isNullOrUndefined(item?.text) && f_item?.text == item?.text) || (!isNullOrUndefined(item.icon) && f_item.icon == item.icon)) && (f_item as any).uID == item?.uID)
                            (f_item as any).dClass = 'active';
                        else
                            (f_item as any).dClass = '';
                    }
                    if (f_item.items.length > 0) {
                        f_item.items.forEach(s_item => {
                            if (type == '2') {
                                if (((!isNullOrUndefined(item?.text) && s_item?.text == item?.text) || (!isNullOrUndefined(item.icon) && s_item.icon == item.icon)) && (s_item as any).uID == item?.uID)
                                    (s_item as any).dClass = 'active';
                                else
                                    (s_item as any).dClass = '';
                            }
                            if (s_item.items.length > 0) {
                                s_item.items.forEach(t_item => {
                                    if (type == '3') {
                                        if (((!isNullOrUndefined(item?.text) && t_item?.text == item?.text) || (!isNullOrUndefined(item.icon) && t_item.icon == item.icon)) && (t_item as any).uID == item?.uID)
                                            (t_item as any).dClass = 'active';
                                        else
                                            (t_item as any).dClass = '';
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

    }

    getIdFromPath(inputString: string) {
        const lastIndex = inputString.lastIndexOf('/');
        if (lastIndex !== -1 && lastIndex + 1 < inputString.length) {
            const part2 = inputString.substring(lastIndex + 1);
            if (part2.includes('&')) {
                let value = part2?.split("&")[0];
                return value
            }
            return part2
        }
        return 0
    }

    getUniqueId(name: string) {
        if (name?.includes('.svg')) {
            var split_string = name?.split("/");
            var newitem = split_string[split_string.length - 1];
            newitem = newitem.replace(/ /g, "").toLowerCase();
            return newitem;
        }
        else
            return name?.replace(/ /g, "").toLowerCase();
    }


    toggleNavBar() {
        let element: HTMLElement = document.getElementsByClassName('navbar-toggler')[0] as HTMLElement;
        if (element.getAttribute('aria-expanded') == 'true') {
            element.click();
        }
    }
    toggleSearch() {
        this.showSearch = !this.showSearch;
        if (this.showSearch)
            this.toggleNavBar();
    }

    resetMenuState() {
        this.currentSelectedParentId = "-1";
        this.currentSelectedId = "-1";
        this.currentSelectedChildId = "-1";
    }
    /*-----------------IH Redirect-----------------------------------*/
    private async authenicateIHRedirect(simpleResponse) {
        await this._localService.Authenticate_ihRedirect(this.encryptedUser, simpleResponse)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        window.open(response?.messageString2, "_blank");
                    } else {
                        this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("buzz-index.getLeadHistory", err.message, simpleResponse);
                this._utilityService.handleErrorResponse(err);
            });
    }

    // Search Code

    getSearchData(txt: any, value: string = "") {
        // FIX: normalize txt into a plain string always
        const q =
            typeof txt === 'string'
                ? txt.trim()
                : txt?.target?.value != null
                    ? String(txt.target.value).trim()
                    : String(txt || '').trim();

        let Search: Search = <Search>{};
        Search.searchText = q;      // ALWAYS clean string now
        this.inputBoxValue = q;
        Search.searchValue = "";

        this.getContactSearch(Search);
    }


    // helper to normalize text: lowercase, remove punctuation, collapse spaces
    private normalize(s: string) {
        return (s || '')
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')   // remove punctuation
            .replace(/\s+/g, ' ')         // collapse whitespace
            .trim();
    }

    goToLink(value: string, str: string = '') {
        const typed = (value || '').toString().trim();
        if (!typed) {
            this.autocomplete.reset();
            return;
        }

        const typedNorm = this.normalize(typed);
        const tokens = typedNorm.split(' ').filter(t => t.length > 0);

        // find all matching items (token inclusion)
        const matches = (this.searchList || []).filter(item => {
            const hay = this.normalize(item.searchText || '');
            return tokens.every(t => hay.includes(t));
        });


        if (matches.length === 1) {
            const found = matches[0];
            const id = (found.searchValue || '').toString();
            console.log('Single match id:', id);

            if (id.includes('ct')) {
                const contactId = id.split('ct')[1]?.trim();
                console.log('Navigating to contact:', contactId);

                // defer navigation slightly so Kendo's internal handlers don't cancel it
                setTimeout(() => {
                    this._router.navigate(['/contact', contactId]).then(nav => {
                        if (!nav) console.warn('Router.navigate returned false');
                    }).catch(err => console.error('Router navigate error:', err));
                    // reset after navigation attempt
                    try { this.autocomplete.reset(); } catch { }
                }, 0);

                return;
            } else if (id.includes('cp')) {
                const companyId = id.split('cp')[1]?.trim();
                //console.log('Navigating to company:', companyId);

                setTimeout(() => {
                    this._router.navigateByUrl(`/company-create?cid=${companyId}`).then(() => {
                        try { this.autocomplete.reset(); } catch { }
                    }).catch(err => console.error('Router navigate error:', err));
                }, 0);

                return;
            } else {
                // unknown id prefix — fallback to search page
                setTimeout(() => {
                    this._router.navigateByUrl(`/home/search?txt=${encodeURIComponent(typed)}`);
                    try { this.autocomplete.reset(); } catch { }
                }, 0);
                return;
            }

        }
        else {
            // unknown id prefix — fallback to search page
            var selected: Search = this.searchList.find(item => item.searchValue === value);
            if (selected) {
                this.searchNavigation(selected);
            }
            else {
                setTimeout(() => {
                    this._router.navigateByUrl(`/home/search?txt=${encodeURIComponent(typed)}`);
                    try { this.autocomplete.reset(); } catch { }
                }, 0);
                return;
            }
        }


    }


    onValueChange(value: string | number) {
        // value is whatever you set in valueField (searchText)
        var selected: Search = this.searchList.find(item => item.searchValue === value);
        if (selected) {
            this.searchNavigation(selected);
        }
    }

    searchNavigation(selected) {
        var id = selected.searchValue;
        if (selected.searchValue.includes('ct')) {
            const contactId = id.split('ct')[1]?.trim();
            console.log('Navigating to contact:', contactId);

            // defer navigation slightly so Kendo's internal handlers don't cancel it
            setTimeout(() => {
                this._router.navigate(['/contact', contactId]).then(nav => {
                    if (!nav) console.warn('Router.navigate returned false');
                }).catch(err => console.error('Router navigate error:', err));
                // reset after navigation attempt
                try { this.autocomplete.reset(); } catch { }
            }, 0);

            return;
        } else if (id.includes('cp')) {
            const companyId = id.split('cp')[1]?.trim();
            //console.log('Navigating to company:', companyId);

            setTimeout(() => {
                this._router.navigateByUrl(`/company-create?cid=${companyId}`).then(() => {
                    try { this.autocomplete.reset(); } catch { }
                }).catch(err => console.error('Router navigate error:', err));
            }, 0);

            return;
        }
    }



    getContactSearch(searchData: Search) {
        debounceTime(3000);
        this.showSpinner = true;
        this._searchContactService.getContactSearchData(this.encryptedUser, this.user?.cLPUserID, searchData)
            .then(async (result: SearchListResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.searchList = response.searchList;
                    this.showSpinner = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("nav-menu.getContactSearch", err.message, null, "cLPUserID " + this.user?.cLPUserID + "," + "searchData " + searchData);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    getImgSrc() {
        switch (this.clpRole) {
            case eCLPRole.StratusExpress:
                this.packageLogo = "../../../../assets/activity/logo/stratusxlogo.png";
                break;
            case eCLPRole.Nimbus:
                this.packageLogo = "../../../../assets/activity/logo/nimbuslogo.png";
                break;
            case eCLPRole.Cirrus:
                this.packageLogo = "../../../../assets/activity/logo/cirruslogo.png";
                break;
            case eCLPRole.Stratus:
                this.packageLogo = "../../../../assets/activity/logo/stratuslogo.png";
                break;
            default:
                this.packageLogo = "../../../../assets/activity/logo/stratuslogo.png";
                break;
        }
        if (this.useImage) {
            if (this.user.cLPCompanyID == 544 || this.user.cLPCompanyID == 1155 || this.user.cLPCompanyID == 1277) {
                this.isShowRightLogo = false;
            }
            this.packageLogo = this.company?.logoURL;
        }
        return this.packageLogo;
    }

    isShowIcon(value: string) {
        if (value?.includes("cpgear"))
            return true;
        else
            return false;
    }

    async appointmentPopUp(apptData, isNewAppt: boolean = false) {
        if (isNewAppt) {
            if (this.user.cLPCompanyID == 1226) {
                if (this.user.cLPUserID != 3893) {
                    this.blnIsIH = true;
                }
            }
            this.shareableAppt = {
                apptId: 0,
                rApptID: apptData?.rApptID,
                cat: this.apptCategory,
                leadContactId: 0,
                ownerId: this.ownerId,
                currentUrlAppt: this.apptCategory == eApptCategory.Contact ? 'contact-appt' : 'lead-appt',
                isNewTab: true,
            };
            this.isShowApptModal = true;
            $('#quickApptModalMenu').modal('show');
        }
        else {
            await this._appointmentSettingService.apptLoad(this.encryptedUser, apptData?.apptID, this.user?.cLPUserID, this.user?.cLPCompanyID).then
                (async (result: ApppointmentResponse) => {
                    if (!isNullOrUndefined(result)) {
                        let appt = UtilityService.clone(result);
                        if (!isNullOrUndefined(appt)) {
                            if (appt.appt.cLPCompanyID == 1226) {
                                if (appt.appt.cLPUserID != 3893) {
                                    this.blnIsIH = true;
                                    if (appt.appt.proposalID > 0) {
                                        this.blnIsIH = false
                                    }
                                }
                            }
                        }
                        this.shareableAppt = {
                            apptId: apptData?.apptID,
                            rApptID: apptData?.rApptID,
                            leadContactId: 0,
                            cat: apptData?.category,
                            ownerId: apptData?.category == eApptCategory.Contact ? apptData?.contactID : apptData?.category == eApptCategory.Lead ? apptData?.leadID : 0,
                            currentUrlAppt: this.apptCategory == eApptCategory.Contact ? 'contact-appt' : 'lead-appt',
                            isNewTab: true,
                        };
                        this.isShowApptModal = true;
                        $('#quickApptModalMenu').modal('show');
                    }
                }).catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    hideQuickApptModal(updateAppt?: UpdateAppt) {
        if (!isNullOrUndefined(updateAppt)) {
            this.closeModalApptModal();
            if (updateAppt.isSave)
                this.leadApptChild?.getApptList();
        }
        this.isShowApptModal = false;
        this.shareableAppt = null;
    }

    closeModalApptModal() {
        const inputElement: HTMLElement = this.closeInputButton.nativeElement as HTMLElement;
        inputElement.click();
    }


    openLiveConnect() {
        //var url = this.liveConnectUrl + 'engage-dash' + '?r=' + this.encryptedUser;
        var url = this.liveConnectUrl + 'engage-dash';
        //var url = this.liveConnectUrl + 'live-connect' + '?r=' + this.encryptedUser;
        //var url = 'https://localhost:44336/' + 'engage-dash' + '?r=' + this.encryptedUser;
        window.open(url, "_blank");
    }


    async liveConnect_isLiveConnectSRSAccount() {
        await this._liveConnectSrvc.liveConnect_isLiveConnectSRSAccount(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.isSRSManager = result?.messageBool;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error('Home.authenticateR.liveConnect_isLiveConnectSRSAccount', err.message, null, 'cLPCompanyId ' + this.user?.cLPCompanyID);
            });
    }

    async IsLiveConnectCLPUser() {
        await this._liveConnectSrvc.IsLiveConnectCLPUser(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.isLiveConnectClpUser = result?.messageBool;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error('Home.authenticateR.IsLiveConnectCLPUser', err.message, null, 'cLPUserID ' + this.user?.cLPUserID);
            });
    }

    getEngageSiteUrl() {
        this._appConfigService.getAppConfigValue(this.encryptedUser, "Engage_Site")
            .then(async (result: ConfigDetails) => {
                if (result) {
                    localStorage.setItem("Engage_Site", result?.configValue);
                }
            });
    }

    //toggleTopMenuHome(item: any, event: MouseEvent, level): void {
    //    event.stopPropagation();
    //    this.isHomeMenuOpened = !this.isHomeMenuOpened;
    //    if (this.isHomeMenuOpened) {
    //        this.activeMenuLevelsHome[level] = item;
    //    }
    //    else {
    //        this.activeMenuLevelsHome = {};
    //    }
    //}

    //toggleTopMenuParent(item: any, event: MouseEvent, level: number): void {
    //    event.stopPropagation();
    //    const isAlreadyOpen = this.activeMenuLevelsParent[level] === item;

    //    if (isAlreadyOpen) {
    //        Object.keys(this.activeMenuLevelsParent).forEach(lvl => {
    //            if (+lvl >= level) {
    //                delete this.activeMenuLevelsParent[+lvl];
    //            }
    //        });
    //    } else {
    //        this.activeMenuLevelsParent[level] = item;
    //        Object.keys(this.activeMenuLevelsParent).forEach(lvl => {
    //            if (+lvl > level) {
    //                delete this.activeMenuLevelsParent[+lvl];
    //            }
    //        });
    //    }
    //}


    //toggleTopMenuProfile(item: any, event: MouseEvent, level): void {
    //    event.stopPropagation();

    //    this.isProfileMenuOpened = !this.isProfileMenuOpened;
    //    if (this.isProfileMenuOpened) {
    //        this.activeMenuLevelsProfile[level] = item;
    //    }
    //    else {
    //        this.activeMenuLevelsProfile = {};
    //    }
    //}

    //@HostListener('document:click', ['$event'])
    //onDocumentClick(event: MouseEvent) {
    //    this.activeMenuLevelsParent = {};
    //    this.activeMenuLevelsHome = {};
    //    this.activeMenuLevelsProfile = {};
    //    this.isHomeMenuOpened = false;
    //    this.isProfileMenuOpened = false;
    //    this.isParentMenuOpened = false;
    //}


    trackByFn(index: number, item: any): any {
        return item.text; // or item.id if available
    }

    mouseEnterHome(item: any, level): void {
        if (level === 0) {
            return;
        }
        this.activeMenuLevelsHome[level] = item;

        const keys = Object.keys(this.activeMenuLevelsHome).map(Number);
        for (let l of keys) {
            if (l > level) {
                delete this.activeMenuLevelsHome[l];
            }
        }
    }

    activeMenuLevelsParent: { [level: number]: any } = {};
    activeMenuLevelsHome: { [level: number]: any } = {};
    activeMenuLevelsProfile: { [level: number]: any } = {};

    mouseEnterParent(item: any, level: number): void {
        if (level === 0) {
            return;
        }

        this.activeMenuLevelsParent[level] = item;

        const keys = Object.keys(this.activeMenuLevelsParent).map(Number);
        for (let l of keys) {
            if (l > level) {
                delete this.activeMenuLevelsParent[l];
            }
        }
    }

    mouseEnterProfile(item: any, level: number): void {
        if (level === 0) {
            return;
        }

        this.activeMenuLevelsProfile[level] = item;

        const keys = Object.keys(this.activeMenuLevelsProfile).map(Number);
        for (let l of keys) {
            if (l > level) {
                delete this.activeMenuLevelsProfile[l];
            }
        }
    }


    isSubMenuVisibleHome(item: any, level: number): boolean {
        return this.activeMenuLevelsHome[level] === item;
    }


    isSubMenuVisibleParent(item: any, level: number): boolean {
        return this.activeMenuLevelsParent[level] === item;
    }

    isSubMenuVisibleProfile(item: any, level: number): boolean {
        return this.activeMenuLevelsProfile[level] === item;
    }

    toggleTopMenuHome(item: any, event: MouseEvent, level: number): void {
        event.stopPropagation();

        // Close other menus
        this.activeMenuLevelsParent = {};
        this.activeMenuLevelsProfile = {};
        this.isProfileMenuOpened = false;
        this.isParentMenuOpened = false;

        // Toggle current menu
        this.isHomeMenuOpened = !this.isHomeMenuOpened;
        if (this.isHomeMenuOpened) {
            this.activeMenuLevelsHome[level] = item;
        } else {
            this.activeMenuLevelsHome = {};
        }
    }

    toggleTopMenuProfile(item: any, event: MouseEvent, level: number): void {
        event.stopPropagation();

        // Close other menus
        this.activeMenuLevelsHome = {};
        this.activeMenuLevelsParent = {};
        this.isHomeMenuOpened = false;
        this.isParentMenuOpened = false;

        // Toggle current menu
        this.isProfileMenuOpened = !this.isProfileMenuOpened;
        if (this.isProfileMenuOpened) {
            this.activeMenuLevelsProfile[level] = item;
        } else {
            this.activeMenuLevelsProfile = {};
        }
    }

    toggleTopMenuParent(item: any, event: MouseEvent, level: number): void {
        event.stopPropagation();

        // Close Home and Profile menus
        this.activeMenuLevelsHome = {};
        this.activeMenuLevelsProfile = {};
        this.isHomeMenuOpened = false;
        this.isProfileMenuOpened = false;

        const isAlreadyOpen = this.activeMenuLevelsParent[level] === item;

        if (isAlreadyOpen) {
            Object.keys(this.activeMenuLevelsParent).forEach(lvl => {
                if (+lvl >= level) {
                    delete this.activeMenuLevelsParent[+lvl];
                }
            });
        } else {
            this.activeMenuLevelsParent[level] = item;
            Object.keys(this.activeMenuLevelsParent).forEach(lvl => {
                if (+lvl > level) {
                    delete this.activeMenuLevelsParent[+lvl];
                }
            });
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        this.activeMenuLevelsParent = {};
        this.activeMenuLevelsHome = {};
        this.activeMenuLevelsProfile = {};
        this.isHomeMenuOpened = false;
        this.isProfileMenuOpened = false;
        this.isParentMenuOpened = false;
    }

}
